import { useEffect, useState } from "react";
import Audioplayer from "./Audioplayer";
import img from "../img/1.jpg";
import firebase from "firebase";
import "firebase/storage";
import "firebase/firestore";
import { BsPlay } from "react-icons/bs";

const Musiccont = (props) => {
  const audioSrc = localStorage.getItem("audio-playing");

  return (
    <div className="music-cont flex-evenly">
      <span
        className="play flex"
        id={props.src}
        onClick={(e) => {
          localStorage.setItem("music-playing", e.target.id);
          props.onPlay();
        }}
      >
        {" "}
        <BsPlay />{" "}
      </span>

      <div className="music-info flex-col-left-center overflow-x">
        <p>{props.tittle}</p>
      </div>
    </div>
  );
};

const Music = () => {
  const [music, setMusic] = useState([]);
  const [allAudiosSrc, setAllAudiosSrc] = useState([]);
  const [dp, setDp] = useState("");
  const [name, setName] = useState("");
  const [caption, setCaption] = useState("");
  const [showPlayer, setShowPlayer] = useState(false);
  const firestore = firebase.firestore();
  const myPhone = localStorage.getItem("music-phone");
  const [audioPlaying, setAudioPlaying] = useState("");

  useEffect((e) => {
    if (myPhone !== null) {
      const userRef = firestore.doc(`users/${myPhone}`);
      userRef.get().then((snap) => {
        const data = snap.data();
        setName(data.name);
        setDp(data.dp);
        setCaption(data.caption);
      });
      const ref = firestore
        .collection(`users/${myPhone}/audios`)
        .orderBy("createdAt", "desc");
      const array = [];
      ref.get().then((docs) => {
        docs.forEach((snap) => {
          const data = snap.data();
          const det = {
            name: data.name,
            phone: data.phone,
            src: data.src,
            dp: data.dp,
            tittle: data.audioName,
          };

          array.push(det);
          setMusic([...music, ...array]);
        });
      });
    }
  }, []);

  useEffect(
    (e) => {
      setAudioSrcs();
    },
    [music]
  );

  function playAudio() {
    const audioSrc = localStorage.getItem("music-playing");
    setAudioPlaying(audioSrc);
    setShowPlayer(true);
  }

  function setAudioSrcs() {
    var sources = [];
    music.forEach((a) => {
      sources.push(a.src);
    });
    setAllAudiosSrc([...sources]);
  }

  function playNext(e) {
    var srcs = allAudiosSrc;
    const audioSrc = localStorage.getItem("music-playing");
    var audioIndex = srcs.indexOf(audioSrc);
    var nextAudioIndex = audioIndex + 1;
    var nextAudio = srcs[nextAudioIndex];


    localStorage.setItem("music-playing", nextAudio);
    setAudioPlaying(nextAudio);
    setShowPlayer(true);

    console.log(nextAudio);
    console.log(nextAudioIndex);
  }

  return (
    <div className="music-page page">
      {showPlayer && (
        <Audioplayer src={audioPlaying} onEnd={(e) => playNext()} />
      )}

      <div className="top flex-start">
        <img src={dp} />
        <div className="info flex-col-left-center">
          <h2>{name}</h2>
          <span>{caption}</span>
        </div>
      </div>
      <div className="center">
        <ul className="all-musics flex-col-start">
          {music.map((a) => {
            return (
              <Musiccont
                key={a.tittle}
                name={a.name}
                tittle={a.tittle}
                src={a.src}
                dp={a.dp}
                onPlay={(e) => playAudio(e)}
              />
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default Music;
